import React from 'react';
import About from './About';
import Contact from './Contact';

const Home = () => {
    return (
        <>
            <div className="page-header section-dark">
                <div className="filter"></div>
                <div className="content-center">
                    <div className="header_container">
                        <div className="title-brand">
                            <h1 className="presentation-title">One.all</h1>
                            <div className="fog-low"><img src="../assets/images/fog-low.png" alt="" /></div>
                            <div className="fog-low right"><img src="../assets/images/fog-low.png" alt="" /></div>
                        </div>
                        <h2 className="presentation-subtitle text-center">Let's do something amazing! </h2>
                    </div>
                </div>
                <div className="moving-clouds"></div>
            </div>
            <About />
            <Contact />
        </>
    )
}

export default Home
